import { PageKey } from '@core/enums/page-keys.enum';
import { ExportControlStatus } from '@core/model/export-control/export-control-status.enum';
import { ExportControlLevel } from '@core/model/export-control/export-control-level.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum ExportControlValidationStep {
  Evaluate = 'Evaluate',
  Failure = 'Failure',
}

export const exportControlValidationFlow: CheckinWorkflow<ExportControlValidationStep> = {
  id: FlowId.ExportControlValidation,
  entry: ExportControlValidationStep.Evaluate,
  steps: {
    [ExportControlValidationStep.Evaluate]: {
      id: ExportControlValidationStep.Evaluate,
      next: (variables) => {
        const exportControl = variables.exportControl;
        const restrictedCountryAndCitizenship =
          exportControl != null &&
          exportControl.status == null &&
          exportControl.countryOfResidence?.restrictionLevel != null &&
          exportControl.lastGrantedCitizenship?.restrictionLevel != null &&
          exportControl.countryOfResidence.restrictionLevel === ExportControlLevel.Red &&
          exportControl.lastGrantedCitizenship.restrictionLevel === ExportControlLevel.Red;

        return !exportControl ||
          exportControl.status === ExportControlStatus.NotAuthorized ||
          restrictedCountryAndCitizenship
          ? { nextStep: ExportControlValidationStep.Failure }
          : { complete: true };
      },
    },
    [ExportControlValidationStep.Failure]: {
      id: ExportControlValidationStep.Failure,
      page: PageKey.EXPORT_CONTROL_FAIL,
      next: () => ({ bubble: 'exit' }),
      back: () => ({ bubble: 'exit' }),
      exit: () => ({ bubble: 'exit' }),
    },
  },
};
